<ng-container *transloco="let t">
  <app-creative-preview
    [creativeType]="creative().creativeType"
    [assets]="creative()"
    [asins]="creative().creativeAsins?.[0]"
    class="group"
  >
    <div previewHeader class="flex w-full items-center justify-between">
      <div class="flex items-center gap-2">
        <IBadge
          [color]="creative().state === State.ON ? 'green' : 'gray'"
          variant="soft"
          size="xs"
          [icon]="creative().state === State.ON ? 'playCircle' : 'pauseCircle'"
          [label]="
            t(creative().state === State.ON ? 'creative-preview.status_active' : 'creative-preview.status_paused')
          "
        />
        <IBadge color="gray" size="xs" [label]="t(creativeTypeLabelKeys[creative().creativeType])" />
        <span class="text-muted-foreground">
          {{ t("creative-display.creative_number", { count: creative().creativeAsins?.length }) }}
        </span>
        @if (storePage(); as page) {
          <div class="border-l pl-2">
            <span class="text-muted-foreground">
              {{ isStoreSpotlight() ? t("sb-form-ad-format.store") : t("sb-form-ad-format.store_page") }}
            </span>
            <a iButtonLink [href]="page.storePageUrl" target="_blank" rel="noopener noreferrer">
              {{ isStoreSpotlight() ? page.storeName : page.storePageName }}
              <IIcon name="arrowUpRight" />
            </a>
          </div>
        }
      </div>
      @if (!readOnly()) {
        <div class="flex items-center gap-2">
          <button
            iButton
            variant="secondary"
            size="icon-sm"
            class="overflow-visible opacity-0 transition-opacity group-hover:opacity-100"
            [iDropdownMenuTrigger]="creativeMenu"
            placement="bottom-end"
          >
            <IIcon name="ellipsis" />
          </button>
          <ng-template #creativeMenu>
            <IDropdownMenu>
              <button iDropdownMenuItem (click)="toggleStatus()">
                <IIcon [name]="creative().state === State.ON ? 'pause' : 'play'" />
                {{
                  t(
                    creative().state === State.ON
                      ? "creative-display.pause_ad_line"
                      : "creative-display.reactivate_ad_line"
                  )
                }}
              </button>
              @if (!isProductCollection()) {
                <button iDropdownMenuItem (click)="manageAssets()">
                  <IIcon name="image" />
                  {{ t("creative-preview.manage_assets") }}
                </button>
                <button iDropdownMenuItem (click)="manageAsins()">
                  <IIcon name="package" />
                  {{ t("creative-preview.manage_asins") }}
                </button>
              }
              <button iDropdownMenuItem variant="danger" [disabled]="!canDeleteCreative()" (click)="deleteCreative()">
                <IIcon name="trash" />
                {{ t("creative-display.delete_ad_line") }}
              </button>
            </IDropdownMenu>
          </ng-template>
        </div>
      }
    </div>
    <div previewFooter class="mb-2 space-y-2 empty:hidden">
      <app-creative-rejected-ads [creative]="creative()" />
      @if (isProductCollection()) {
        <IAlert type="warning">
          @if (requireManualMigration()) {
            {{ t("sb-form-crea-preview.manual_migration_required") }}
          } @else {
            {{ t("sb-form-crea-preview.manual_collection_available") }}
          }
          @if (!readOnly()) {
            <button
              iButton
              variant="secondary"
              class="text-foreground ml-2"
              (click)="migrateToManualCollection()"
              [loading]="migrationLoading()"
            >
              {{ t("sb-creative-edit.manual_migration_required") }}
            </button>
          }
        </IAlert>
      }
    </div>
    @let hasMoreThanOneCreative = (creative().creativeAsins?.length ?? 0) > 1;
    @if (hasMoreThanOneCreative) {
      <div previewFooter class="flex flex-col gap-2 border-t pt-3">
        <button
          size="xs"
          class="text-muted-foreground w-fit justify-start"
          iButton
          variant="ghost"
          (click)="toggleOpened()"
        >
          {{
            t("creative-preview.show_n_more", {
              count: (creative().creativeAsins?.length ?? 0) - 1,
            })
          }}
          @if (isOpened()) {
            <IIcon name="chevronDown" />
          } @else {
            <IIcon name="chevronRight" />
          }
        </button>
        <IAccordion [isOpen]="isOpened()">
          <div class="flex flex-col gap-4 pt-2">
            @for (sbAsins of creative().creativeAsins; track sbAsins) {
              @if (!$first) {
                @if (creative().creativeType === SbCreativeType.video) {
                  <app-video-asin-preview [asin]="sbAsins.asin1" />
                } @else {
                  <app-asin-items-preview [asins]="sbAsins" />
                }
              }
            }
          </div>
        </IAccordion>
      </div>
    }
  </app-creative-preview>
</ng-container>
